import * as React from 'react'
import {ErrorDisplayProps, withErrorSubscribe} from './hoc/withErrorSubscribe'
import {ErrorMessageProps, withErrorMessage} from './hoc/withErrorMessage'

const PPErrorLabel = (props: ErrorDisplayProps & ErrorMessageProps) => {
    return null
}
PPErrorLabel.displayName = 'PPErrorLabel'
export default withErrorSubscribe(withErrorMessage(PPErrorLabel))
